<template>
    <template v-for="(item, index) in orderItemsWithSubitemsOnSeparatePicksheet(order)" :key="index">
        <template v-for="item_index in item.quantity" :key="item_index">

            <div class="text-4xl">
                <span class="text-green"><b>PRODUCE</b></span>
                <span class="ml-2 text-red"><b>EXPRESS</b></span>
            </div>

            <table>
                <thead>
                    <tr>
                        <th class="pt-4 pb-1 text-left text-lg text-gray-dark font-bold w-1/2">
                            Customer Info
                        </th>
                        <th class="pt-4 pb-1 text-left text-lg text-gray-dark font-bold w-1/2">
                            Order Info
                        </th>

                    </tr>
                    <tr>
                        <td class="font-semibold align-top">
                            <div v-if="order.is_wholesale">{{ order.customer.name }}</div>
                            <div v-else>{{ order.shipping_first_name }} {{ order.shipping_last_name }}</div>
                        </td>
                        <td class="font-semibold align-top">
                            <div><span class="inline-block w-24">Order #:</span>{{ order.id }}</div>
                            <div><span class="inline-block w-24">Page #:</span>{{ currentSeparatePicksheetPage(order, index, item_index) }} of {{ separatePicksheetPages(order) }}</div>
                        </td>
                    </tr>
                </thead>
            </table>

            <div class="pt-2 pb-1 text-left text-lg text-gray-dark font-bold">
                Item
            </div>
            <div>
                <span v-html="boldProductHighlights(item.title, item.product.picksheet_highlights)"/>
                <span v-if="item.description"> - <span v-html="boldProductHighlights(item.description, item.product.picksheet_highlights)"/></span>
                <span v-if="item.size"> - <span v-html="boldProductHighlights(item.size, item.product.picksheet_highlights)"/></span>
                ({{ item_index }} of {{ item.quantity }})
            </div>

            <th class="pt-2 pb-1 text-left text-lg text-gray-dark font-bold">
                Item Contents
            </th>

            <table class="w-full">
                <tbody class="striped">
                    <tr class="not_striped border-b border-gray">
                        <th class="py-1 text-center px-2 w-1">QC</th>
                        <th class="py-1 text-left px-2">Qty</th>
                        <th class="py-1 text-left pl-4 pr-2 w-1/5">UofM</th>
                        <th class="py-1 text-left px-2">Item</th>
                        <th class="py-1 text-center px-2">Zone</th>
                    </tr>
                    <tr
                        v-for="(subitem, si_index) in orderItemsSortedByZone(shown_subitems(item))"
                        class="border-b border-gray"
                        :key="index + '_' + si_index + '_subitem'"
                        :class="{
                            'border-b-2 border-gray-600': orderItemLastInZone(shown_subitems(item), si_index)
                        }"
                    >
                        <td class="text-center px-2"><input type="checkbox" class="border-gray-dark rounded-sm" disabled></td>
                        <td v-if="subitem.product.gift_card == 1" class="text-left px-2">{{ subitem.quantity }}</td>
                        <td v-else class="text-left px-2">{{ subitem.quantity / item.quantity }}</td>
                        <td v-if="order.is_wholesale" class="text-left pl-4 pr-2 whitespace-nowrap"><span v-html="boldProductHighlights(subitem.size, subitem.product.picksheet_highlights)"/></td>
                        <td v-else class="text-left pl-4 pr-2 whitespace-nowrap"><span v-html="boldProductHighlights(subitem.description, subitem.product.picksheet_highlights)"/></td>
                        <td class="text-left px-2">
                            <span v-html="boldProductHighlights(subitem.title, subitem.product.picksheet_highlights)"/>
                            <span v-if="order.is_wholesale && subitem.description"> - <span v-html="boldProductHighlights(subitem.description, subitem.product.picksheet_highlights)"/></span>
                            <div v-show="subitem.product_notes" class="text-xs italic"><span v-html="boldProductHighlights(subitem.product_notes, subitem.product.picksheet_highlights)"/></div>
                        </td>
                        <td v-if="!order.is_wholesale" class="text-right px-2">{{ subitem.product.retail_zone }}</td>
                        <td v-else-if="order.customer?.type == 'School'" class="text-right px-2">
                            {{ subitem.product.school_zone }}
                        </td>
                        <td v-else class="text-right px-2">{{ subitem.product.zone }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="page-break"></div>
            
        </template>
    </template>
</template>

<script>
export default {
    components: {
    },

    props: ['order'],

    methods: {
        orderItemsSortedByZone(order_items)
        {
            let zone_type = 'zone'
            let subzone_type = 'subzone'
            if(!this.order.is_wholesale){
                zone_type = 'retail_zone'
                subzone_type = 'retail_subzone'
            }else if(this.order.customer?.type === 'School'){
                zone_type = 'school_zone'
                subzone_type = 'school_subzone'
            }

            return order_items.sort((a, b) => {
                if (a.product[zone_type] < b.product[zone_type]) return -1;
                else if (a.product[zone_type] > b.product[zone_type]) return 1;
                else {
                    if (a.product[subzone_type] < b.product[subzone_type]) return -1;
                    else if (a.product[subzone_type] > b.product[subzone_type]) return 1;
                    return 0;
                }
            });
        },
        orderItemLastInZone(order_items, oi_index)
        {
            return this.orderItemsSortedByZone(order_items)[oi_index + 1] != undefined
                && this.orderItemsSortedByZone(order_items)[oi_index].zone != this.orderItemsSortedByZone(order_items)[oi_index + 1].zone;
        },
        shown_subitems (order_item) {
            return order_item.subitems.filter(subitem => !order_item.product.subproducts.find(subproduct => subproduct.subproduct_id == subitem.product_id) || !order_item.product.subproducts.find(subproduct => subproduct.subproduct_id == subitem.product_id).hidden_from_customer)
        },
        orderItemsWithSubitemsOnSeparatePicksheet(order)
        {
            return order.order_items.filter(oi => (oi.product.include_subitems_on_picksheet && oi.product.category.subitems_on_separate_picksheet == 1 && this.shown_subitems(oi).length > 0));
        },
        currentSeparatePicksheetPage(order, item_index, item_subindex)
        {
            return item_subindex + this.orderItemsWithSubitemsOnSeparatePicksheet(order).reduce(function(accumulator, oi, oi_index){
                if (oi_index < item_index) return accumulator + Number(oi.quantity);
                else return accumulator;
            }, 0);
        },
        separatePicksheetPages(order)
        {
            return this.orderItemsWithSubitemsOnSeparatePicksheet(order).reduce(function(accumulator, oi){
                return accumulator + Number(oi.quantity);
            }, 0);
        },
        boldProductHighlights(string, wordsToHighlight = "") {
            if (string == null) return string;

            let wordsToHighlightArr = []

            if (wordsToHighlight != null){
                wordsToHighlightArr = wordsToHighlight.split(',').map(w =>w.trim());
            }
            wordsToHighlightArr.push("case") //always hightlight "case"
            const regex = new RegExp(`\\b(${wordsToHighlightArr.join('|')})\\b`, 'gi');
            return string.replace(regex, match => `<b>${match}</b>`);
        }
    },
}

</script>
